export { default as PaneledTabs } from "./PaneledTabs";
